import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Modal, Row, Select, Switch } from "antd";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { formatNumber } from "../../../../../utils";
import { salesCredentialsSchema } from "../../../../validattion";
import { yupResolver } from "@hookform/resolvers/yup";

const { Option } = Select;

const CreateSalesModal = (props) => {
  const {
    visible,
    formMode,
    closeModal,
    one_sale,
    CreateSales,
    UpdateSales,
    GetAllProducts,
    allProducts,
  } = props;
  const [loading, setLoading] = useState(false);
  const [buyer_phone, setBuyerPhone] = useState("");
  const [unit_price, setUnitPrice] = useState("");
  const [amount, setAmount] = useState("");
  const [product, setProduct] = useState(null);
  const [error, setError] = useState(false);

  const checkMode = formMode === "CREATE_MODE";

  const getProductRecords = async () => {
    const res = await GetAllProducts();
    if (!res.success) {
      setLoading(false);
      toast.error(`Error`);
    }
  };
  useEffect(() => {
    getProductRecords();
  }, [GetAllProducts]);

  // Form
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(salesCredentialsSchema),
  });

  const closeSalesModal = () => {
    setBuyerPhone("");
    setUnitPrice("");
    setAmount("");
    reset({
      buyer_phone: "",
      buyer_name: "",
      product: "",
    });
    closeModal();
  };

  const createRawMaterialInventory = async (data) => {
    setLoading(true);
    if (buyer_phone === "") {
      setError(true);
    }
    if (formMode === "CREATE_MODE") {
      const createObj = {
        ...data,
        buyer_phone,
        amount,
        unit_price,
      };
      const res = await CreateSales(createObj);
      if (res.success) {
        setLoading(false);
        toast.success("Sales record Created Successfully", {
          pauseOnHover: false,
        });
        closeSalesModal();
        requestAnimationFrame(() => {
          setLoading(false);
        });
      } else if (!res.success && res.message === undefined) {
        setLoading(false);
        toast.error("Network Error", {
          pauseOnHover: true,
        });
      } else {
        setLoading(false);
        toast.error(res.message, {
          pauseOnHover: true,
        });
      }
      setLoading(false);
    } else if (formMode === "UPDATE_MODE") {
      const updateObj = {
        ...data,
        id: one_sale?.id,
        buyer_phone,
        amount,
        unit_price,
      };
      const res = await UpdateSales(updateObj);
      if (res.success) {
        setLoading(false);
        toast.success("Sales Record Updated Successfully", {
          pauseOnHover: false,
        });
        closeSalesModal();
        requestAnimationFrame(() => {
          setLoading(false);
        });
      } else if (!res.success && res.message === undefined) {
        setLoading(false);
        toast.error("Network Error", {
          pauseOnHover: true,
        });
      } else {
        setLoading(false);
        toast.error(res.message, {
          pauseOnHover: true,
        });
      }
    }
  };
  const getProduct = watch("product");
  useEffect(() => {
    if (getProduct) {
      const getPrice = allProducts.find(
        (item) => item?.id === getProduct
      ).price;
      setUnitPrice(getPrice);
    }
  }, [getProduct]);

  // const checkOnchange = (value) => {
  //   const getPrice = allProducts.find((item) => item?.id === value).price;
  //   setUnitPrice(getPrice);
  //   setProduct(value);
  // };
  const productsChildren = allProducts?.map((obj) => {
    return (
      <Option key={obj.id} value={obj.id}>
        {obj.name}
      </Option>
    );
  });
  useEffect(() => {
    if (one_sale) {
      setValue("product", one_sale?.product);
      setProduct(one_sale?.product);
      setAmount(one_sale?.amount);
      setValue("buyer_name", one_sale?.buyer_name);
      setBuyerPhone(one_sale?.buyer_phone);
      setUnitPrice(one_sale?.unit_price);
      setValue("quantity", one_sale?.quantity);
    }
  }, [one_sale]);
  const getQuantity = watch("quantity");
  useEffect(() => {
    if (one_sale) {
      setAmount(one_sale?.amount);
    }
    if (unit_price && getQuantity) {
      setAmount(unit_price * getQuantity);
    } else {
      setAmount(0);
    }
  }, [one_sale, unit_price, getQuantity]);

  const updatePhoneNumber = (event) => {
    const regex = /^[0-9]{0,13}$/;
    let num = event.target.value.replaceAll(" ", "");
    if (regex.test(num)) {
      let tempCardNumber = (
        num.slice(0, 3).replace(/(.{3})/g, "$1 ") +
        num.slice(3, 6).replace(/(.{3})/g, "$1 ") +
        num.slice(6, 10).replace(/(.{4})/g, "$1 ") +
        num.slice(10, 14).replace(/(.{4})/g, "$1 ")
      ).trim();
      setBuyerPhone(tempCardNumber);
    }
  };
  return (
    <>
      <Modal
        visible={visible}
        title={
          <p style={{ fontWeight: "bold" }}>
            {checkMode ? "Add New Purchase" : `Update New Purchase`}
          </p>
        }
        footer={null}
        onCancel={closeSalesModal}
        maskClosable={false}
        width={"500px"}
      >
        <form
          onSubmit={handleSubmit(createRawMaterialInventory)}
          autoComplete="off"
        >
          <div className="content">
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Buyer's Name</label>
                  <input
                    name="buyer_name"
                    className="ant-input ant-input-lg"
                    placeholder="Type in Name"
                    {...register("buyer_name", { required: true })}
                    // value={buyer_name}
                    // onChange={(event) => setBuyerName(event?.target?.value)}
                  />

                  {errors.buyer_name && (
                    <span className="error">
                      Buyer's name is a required field
                    </span>
                  )}
                </Col>
              </Row>
            </div>
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Buyer's Phone Number</label>
                  <input
                    name="buyer_phone"
                    className="ant-input ant-input-lg"
                    placeholder="Type in Number"
                    value={buyer_phone}
                    onChange={updatePhoneNumber}
                  />
                  {error && buyer_phone && (
                    <span className="error">
                      Buyer's phone number is a required field
                    </span>
                  )}
                </Col>
              </Row>
            </div>{" "}
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Product</label>
                  <Controller
                    name="product"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <Select
                        allowClear
                        name="product"
                        placeholder="Select a product"
                        style={{ width: "100%" }}
                        size="large"
                        value={value}
                        onChange={onChange}
                      >
                        {productsChildren}
                      </Select>
                    )}
                  />
                  {errors.product && (
                    <span className="error">Product is a required field</span>
                  )}
                </Col>
              </Row>
            </div>
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Product Price</label>
                  <input
                    name="unit_price"
                    className="ant-input ant-input-lg"
                    disabled
                    value={unit_price ? formatNumber(unit_price) : ""}
                  />
                </Col>
              </Row>
            </div>
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Quantity</label>
                  <input
                    name="quantity"
                    className="ant-input ant-input-lg"
                    placeholder="Type in Quantity"
                    type="number"
                    {...register("quantity", { required: true })}
                    defaultValue={checkMode ? null : one_sale?.quantity}
                  />

                  {errors.product && (
                    <span className="error">Product is a required field</span>
                  )}
                </Col>
              </Row>
            </div>
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Total Price</label>
                  <input
                    name="total_price"
                    className="ant-input ant-input-lg"
                    value={
                      typeof amount === "string"
                        ? Number(amount).toLocaleString()
                        : formatNumber(JSON.stringify(amount))
                    }
                    // onChange={(event) => setAmount(event?.target?.value)}
                    onChange={(event) => {
                      const value = event.target.value.replace(/,/gi, "");

                      if (isNaN(value)) return;

                      setAmount(value);
                    }}
                  />
                </Col>
              </Row>
            </div>
          </div>
          <Divider />
          <Row style={{ margin: "2rem 0" }}>
            <Col xs={24} style={{ textAlign: "right" }}>
              <Button
                loading={loading}
                type="primary"
                htmlType="submit"
                style={{ marginRight: "10px" }}
              >
                {formMode === "CREATE_MODE" ? "Save" : "Update"} Purchase
              </Button>
            </Col>
          </Row>
        </form>
      </Modal>
    </>
  );
};

export default CreateSalesModal;
